import Modal from "../../components/modal";
import Button from "../../components/button";
import AddDeviceModal from "../../components/add-device-modal";
import EditSvg from "../../components/icons/edit";
import React, { useContext, useEffect, useState } from "react";
import { DataContext } from "../../context/dataProvider";
import { IUserServer, SUBSCRIPTION_TYPE } from "../../context/types";
import { useNavigate } from "react-router";
import { getAmountDaysLeft } from "../../utils/dayLeft";
import styles from "./styles.module.css";
import LogoSvg from "../../components/icons/logo";
import { switchToPersonalSubscription } from "../../api/users";
import { getDevices } from "../../api/user-server";
import { usePlatform } from "../../hooks/usePlatform";
import classNames from "classnames";
import { openExternalUrl } from "../../utils/telegram";
import { HelpLink } from "../../common/help";

function HomePage() {
  const context = useContext(DataContext);
  const navigation = useNavigate();
  const { isTelegram } = usePlatform();
  const [addDeviceOpen, setAddDeviceOpen] = useState(false);
  const [connectedDevicesCount, setConnectedDevicesCount] = useState(0);
  const [modalHeight, setModalHeight] = useState(0);

  const userServerId = context?.user?.userServer?.userId ?? null;

  useEffect(() => {
    if (!userServerId) return;
    let cancelled = false;
    getDevices()
      .then((result) => {
        if (!cancelled) setConnectedDevicesCount(result.total);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [userServerId]);

  if (!context) {
    return null;
  }

  const { user } = context;

  const handleClickToDevices = () => {
    navigation("/devices");
  };

  const handleClickStartFree = () => {
    navigation("/settings");
  };

  const handleClickToBuy = () => {
    navigation("/select-tariff");
  };

  const handleClickToSelectDevice = () => {
    navigation("/settings");
  };

  const handleClickToAddDevice = () => {
    setAddDeviceOpen(true);
  };

  const handleContactUs = () => {
    openExternalUrl(HelpLink);
  };

  const handleClickToPersonalSubscription = async () => {
    try {
      await switchToPersonalSubscription();
      await context.updateData();
    } catch (error) {
      console.error("Error switching to personal subscription:", error);
    }
  };

  const contentHeaderClass = classNames({
    [styles.contentHeaderWeb]: !isTelegram,
  });

  const contentDefault = (
    <div className={styles.content}>
      <div className={contentHeaderClass}>
        <h1>OpenWay</h1>
        <p>
          безопасное подключение
          <br />
          без ограничения трафика
        </p>
      </div>
      <div className={styles.containerLogo}>
        <LogoSvg />
      </div>
    </div>
  );

  const contentUserServer = (userServer: IUserServer) => {
    let title = "";
    let subtitle = "";
    let dayLeft = 0;
    const isExpired = new Date(userServer.subscriptionEndDate) < new Date();

    if (userServer.subscriptionType === SUBSCRIPTION_TYPE.TEST) {
      if (user?.business && userServer.isEnabled) {
        title = "Подписка активна";
        subtitle = "Действует тариф, предоставленный\n организацией «" + user?.business?.name + "»";
      } else if (user?.business && !userServer.isEnabled && !isExpired) {
        title = "Вы отключены";
        subtitle = "Ваш доступ к корпоративной подписке «" + user?.business?.name + "» закрыт. Обратитесь к организации для решения проблемы или перейдите на личную подписку, кликнув кнопку ниже.";
      } else if (isExpired) {
        title = "Пробная версия истекла";
        subtitle = "Оформите подписку,\n чтобы вернуть доступ к VPN";
      } else {
        dayLeft = getAmountDaysLeft(userServer.subscriptionEndDate);
        title = "Пробная версия";
        subtitle = "Осталось дней: " + dayLeft;
        if (dayLeft === 1) {}
      }
    }

    if (userServer.subscriptionType !== SUBSCRIPTION_TYPE.TEST) {
      if (isExpired) {
        title = "Подписка истекла";
        subtitle = "Продлите подписку,\n чтобы вернуть доступ к VPN";
      } else {
        if (user?.business && userServer.isEnabled) {
          title = "Подписка активна";
          subtitle = "Действует тариф, предоставленный\n организацией «" + user?.business?.name + "»";
        } else if (user?.business && !userServer.isEnabled && !isExpired) {
          title = "Вы отключены";
          subtitle = "Ваш доступ к корпоративной подписке «" + user?.business?.name + "» закрыт. Обратитесь к организации для решения проблемы или перейдите на личную подписку, кликнув кнопку ниже.";
        } else {
          dayLeft = getAmountDaysLeft(userServer.subscriptionEndDate);
          title = "Подписка активна";
          const endDate = new Date(userServer.subscriptionEndDate);
          if (dayLeft > 3) {
            subtitle = `Действует до ${endDate.toLocaleDateString("ru-RU")}`;
          } else {
            subtitle = "Осталось дней: " + dayLeft;
          }
        }
      }
    }

    const isManuallyDisabled = !userServer.isEnabled && !isExpired;

    if (isManuallyDisabled) {
      if (user?.business) {
        title = "Вы отключены";
        subtitle =
          "Ваш доступ к корпоративной подписке «" +
          user?.business?.name +
          "» закрыт. Обратитесь к организации для решения проблемы или перейдите на личную подписку, кликнув кнопку ниже.";
      } else {
        title = "Доступ отключен";
        subtitle = "VPN-доступ отключен. Обратитесь в поддержку OpenWay.";
      }
      return (
        <div className={styles.content}>
          <div className={contentHeaderClass}>
            <h1>{title}</h1>
            <p className={styles.subtitle}>{subtitle}</p>
          </div>
          <div className={styles.containerLogo}>
            <LogoSvg/>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.content}>
        <div className={contentHeaderClass}>
          <h1>{title}</h1>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>
        <button type="button" className={styles.devicesPill} onClick={handleClickToDevices}>
          {connectedDevicesCount} из {userServer.deviceLimit ?? 0} устройств
          <EditSvg />
        </button>
        <div className={styles.containerLogo}>
          <LogoSvg />
        </div>
      </div>
    );
  };

  let content = <></>;

  let actionBtns = (
    <Modal user={user} onHeightChange={setModalHeight}>
      <Button label={"Начать бесплатно"} onClick={() => handleClickStartFree()} />
      <Button label={"Оформить подписку"} variant={"secondary"} onClick={() => handleClickToBuy()} />
    </Modal>
  );

  if (!user?.userServer) {
    content = contentDefault;
  }

  if (user?.userServer) {
    const userServer = user.userServer;
    const isExpired = new Date(userServer.subscriptionEndDate) < new Date();
    content = contentUserServer(userServer);

    const isDeviceLimitExceeded = connectedDevicesCount > (userServer.deviceLimit ?? 0);
    const deviceLimitAlert = isDeviceLimitExceeded ? (
      <div className={styles.deviceLimitAlert}>
        <h3>Превышен лимит устройств</h3>
        <p>
          Чтобы не потерять доступ,{" "}
          <button type="button" className={styles.alertLink} onClick={() => handleClickToAddDevice()}>
            расширьте подписку
          </button>{" "}
          или{" "}
          <button type="button" className={styles.alertLink} onClick={() => handleClickToDevices()}>
            удалите устройства
          </button>{" "}
          вручную, прежде чем они удалятся автоматически
        </p>
      </div>
    ) : null;

    if (userServer.subscriptionType === SUBSCRIPTION_TYPE.TEST) {
      if (isExpired) {
        actionBtns = (
          <Modal user={user} alert={deviceLimitAlert} onHeightChange={setModalHeight}>
            <Button label={"Оформить подписку"} onClick={() => handleClickToBuy()} />
          </Modal>
        );
      } else {
        actionBtns = (
          <Modal user={user} alert={deviceLimitAlert} onHeightChange={setModalHeight}>
            <Button label={"Добавить устройство"} onClick={() => handleClickToSelectDevice()} />
            <Button label={"Оформить подписку"} variant="secondary" onClick={() => handleClickToBuy()} />
          </Modal>
        );
      }
    }

    if (userServer.subscriptionType !== SUBSCRIPTION_TYPE.TEST) {
      if (isExpired) {
        actionBtns = (
          <Modal user={user} alert={deviceLimitAlert} onHeightChange={setModalHeight}>
            <Button label={"Продлить подписку"} onClick={() => handleClickToBuy()} />
          </Modal>
        );
      } else {
        actionBtns = (
          <Modal user={user} alert={deviceLimitAlert} onHeightChange={setModalHeight}>
            <Button label={"Добавить устройство"} onClick={() => handleClickToSelectDevice()} />
            <Button label={"Продлить подписку"} variant="secondary" onClick={() => handleClickToBuy()} />
          </Modal>
        );
      }
    }

    if (user?.business && userServer.isEnabled) {
      actionBtns = (
        <Modal user={user} onHeightChange={setModalHeight}>
          <Button label={"Добавить устройство"} onClick={() => handleClickToSelectDevice()} />
        </Modal>
      );
    } else if (user?.business && !userServer.isEnabled && !isExpired) {
      actionBtns = (
        <Modal user={user} onHeightChange={setModalHeight}>
          <Button label={"Перейти на личную подписку"} onClick={() => handleClickToPersonalSubscription()} />
        </Modal>
      );
    } else if (!userServer.isEnabled && !isExpired) {
      actionBtns = (
        <Modal user={user} onHeightChange={setModalHeight}>
          <Button label={"Связаться с нами"} onClick={() => handleContactUs()} />
        </Modal>
      );
    }
  }

  return (
    <div
      className={styles.home}
      style={modalHeight ? ({ "--modal-height": `${modalHeight}px` } as React.CSSProperties) : undefined}
    >
      {content}
      {actionBtns}
      {user?.userServer && (
        <AddDeviceModal
          open={addDeviceOpen}
          onClose={() => setAddDeviceOpen(false)}
          userServer={user.userServer}
        />
      )}
    </div>
  );
}

export default HomePage;